/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Files_DescriptionInputs */

const es_walkthrough_settings_files_description = /** @type {(inputs: Walkthrough_Settings_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá, filtrá y administrá todos los archivos ingestados. Podés re-ingestar, eliminar, subir nuevos archivos y activar la sincronización automática desde acá.`)
};

const en_walkthrough_settings_files_description = /** @type {(inputs: Walkthrough_Settings_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search, filter, and manage all ingested files. You can re-ingest, delete, upload new files, and toggle auto-sync from here.`)
};

/**
* | output |
* | --- |
* | "Search, filter, and manage all ingested files. You can re-ingest, delete, upload new files, and toggle auto-sync from here." |
*
* @param {Walkthrough_Settings_Files_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_files_description = /** @type {((inputs?: Walkthrough_Settings_Files_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Files_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_files_description(inputs)
	return en_walkthrough_settings_files_description(inputs)
});
export { walkthrough_settings_files_description as "walkthrough.settings_files_description" }